import React from 'react';
import { connect } from 'react-redux';
import { lzCallApi } from '../../../../services/LzApiService';
import { lzShowMediaBrowser, lzShowSuccessMessage } from '../../../../services/LzUtils';
import Grid from '@material-ui/core/Grid';
import LzForm from '../../../commons/forms/form';
import LzFormFieldInput from '../../../commons/forms/fields/input';
import CircularProgress from '@material-ui/core/CircularProgress';
import LzOptionModel from '../../../../models/option';
import DealerModel from '../../../../models/dealer';
import { lzDeepVarSet } from '../../../../services/LzType';

class UpdateProfileComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            model: null,
            optionsHash: {},
            uploadMedia: '',
        };
        this.inputFileRef = React.createRef();
    }

    componentDidMount() {
        this.load();
    }

    getSelectOptions(key) {
        const { optionsHash } = this.state;

        if (optionsHash[key]) {
            return optionsHash[key];
        }

        setTimeout(() => this.loadSelectOptions(key), 200);
    }

    async loadSelectOptions(key) {
        const { optionsHash } = this.state;

        // If already loaded then skip
        if (optionsHash[key]) {
            return;
        }

        // Mark loading
        optionsHash[key] = 'loading';
        this.setState({
            optionsHash: optionsHash,
        });

        // Make the api call and get the data
        const data = await lzCallApi('options/' + key);

        // Load data if call was successful
        // console.log('CRUD OPTIONS DATA', key, data);
        optionsHash[key] = LzOptionModel.parseArray(data, 'id', 'name');
        this.setState({
            optionsHash: optionsHash,
        });
    }

    handleRemoveMedia(fieldName) {
        const { model } = this.state;
        model[fieldName] = null;
        model[fieldName + '_id'] = 0;
        this.setState({ model: model });
    }

    handleUploadMedia(fieldName, mediaCategory, mediaFileType, mediaContentType, mediaIsPrivate) {
        const { model } = this.state;

        lzShowMediaBrowser({
            category: mediaCategory,
            file_type: mediaFileType,
            content_type: mediaContentType,
            is_private: mediaIsPrivate,
        },
            (media) => {
                const updated = Object.assign({}, model);
                updated[fieldName] = media;
                updated[fieldName + '_id'] = media.id;
                this.setState({ model: updated });
            },
            (msg) => {
                // Show error message if required
                console.error('Media-Upload-Err', msg);
            },
        );
    }

    handleUploadMediaSimple(fieldName) {
        this.setState({ uploadMedia: fieldName });
        this.inputFileRef.current.click();
    }

    async onFileChangeCapture(evt) {
        const { uploadMedia } = this.state;
        const file = evt.target.files?.[0];
        if (file && uploadMedia && uploadMedia !== '') {
            // Make the api call to upload the file
            const data = await lzCallApi('media', {
                file: file,
                category: 'general',
                is_private: true,
            }, 'post');

            if (data) {
                this.setState({
                    model: Object.assign({}, this.state.model, { [uploadMedia]: data, [uploadMedia + '_id']: data.id }),
                    uploadMedia: '',
                });
            }
        }
    };

    handleInputChange = (name, value) => {
        // console.log('SET', name, value);
        const data = Object.assign({}, this.state.model);
        lzDeepVarSet(data, name, value);
        this.setState({ model: data });
    };

    async load() {
        // Make the api call and get the data
        const data = await lzCallApi('profile');

        // Load data if call was successful
        if (data) {
            this.setState({ model: data });
        }
    }

    async save() {
        const { model } = this.state;
        const { onUpdate } = this.props;

        // Make the api call and get processed data
        const data = await lzCallApi('profile', new DealerModel(model), 'post');

        // Check if call was successful
        if (data) {
            lzShowSuccessMessage('Your profile was successfully updated!');
            if (onUpdate) {
                onUpdate();
            }
        }
    }

    render() {
        const { model, uploadMedia } = this.state;
        const { inlineWidget, allowSkip, onSkip, appConfig } = this.props;

        return (
            <React.Fragment>

                {model ?
                    <div className={inlineWidget ? 'lz-inline-widget' : ''}>

                        <LzForm
                            noCancel={!allowSkip} cancelLabel="Skip" onCancel={onSkip}
                            showReset resetLabel="Refresh" onReset={() => this.load()}
                            onSubmit={() => this.save()}
                        >
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <LzFormFieldInput fluid required label="Name" placeholder="please enter your full name"
                                        name="name" value={model?.name || ''} onChange={this.handleInputChange} autoFocus />
                                </Grid>
                                <Grid item xs={6}>
                                    <LzFormFieldInput fluid label="Company Name" placeholder="please enter your company name"
                                        name="business_name" value={model?.business_name || ''} onChange={this.handleInputChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <LzFormFieldInput fluid label="Street Address" placeholder="please enter your street address"
                                        value={model?.business_address?.address || ''} onChange={this.handleInputChange} />
                                </Grid>
                                <Grid item xs={2}>
                                    <LzFormFieldInput fluid label="City" placeholder="please enter city" name="business_address.city"
                                        value={model?.business_address?.city || ''} onChange={this.handleInputChange} />
                                </Grid>
                                <Grid item xs={2}>
                                    <LzFormFieldInput fluid label="State" placeholder="please enter state" name="business_address.state"
                                        value={model?.business_address?.state || ''} onChange={this.handleInputChange} />
                                </Grid>
                                <Grid item xs={2}>
                                    <LzFormFieldInput fluid label="Zip" placeholder="please enter zip" name="business_address.zip"
                                        value={model?.business_address?.zip || ''} onChange={this.handleInputChange} />
                                </Grid>
                            </Grid>

                        </LzForm>
                    </div>
                    :
                    <CircularProgress color="inherit" />
                }

                <input
                    type="file"
                    ref={this.inputFileRef}
                    accept="image/png, image/jpeg, image/jpg, image/gif, application/msword, application/vnd.ms-excel, text/plain, application/pdf"
                    onChangeCapture={(evt) => this.onFileChangeCapture(evt)}
                    style={{ display: 'none' }}
                />

            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        appConfig: state.commons.appConfig,
    }
};

export default connect(
    mapStateToProps
)(UpdateProfileComponent);
